import React from 'react';

import {
  isGLS,
  pickServiceGroupId,
  Subscription,
} from '@/types/subscriptions/subscription';

type Props = {
  children?: never;
  subscription: Subscription;
};

export const ServiceName: React.FC<Props> = (props) => {
  const { subscription } = props;
  const id = pickServiceGroupId(subscription);
  if (id && isGLS(id)) {
    if (!subscription.project) {
      return null;
    }
    return <span>{subscription.project.name}</span>;
  }
  return (
    <>
      {subscription.services
        .map((s) => <div key={s.id}>{s.name}</div>)
        .reduce(
          (acc: any, x: any, index: number) =>
            acc === null ? [x] : [acc, <span key={index}>,</span>, x],
          null,
        )}
    </>
  );
};
